import { api } from '@culture/common-helpers/request';

import * as types from './types';

export const submitSubscribeForm = (data) => (dispatch) => {
	dispatch({
		type: types.SUBSCRIBE_FORM_SUBMIT_START
	});

	const subscribersPromise = api('subscribers', data, 'POST');

	subscribersPromise
		.then((response) => {
			dispatch({
				type: types.SUBSCRIBE_FORM_SUBMIT_SUCCESS,
				payload: response
			});
		})
		.catch((err) => {
			dispatch({
				type: types.SUBSCRIBE_FORM_SUBMIT_ERROR,
				payload: err
			});
		});

	return subscribersPromise;
};
